<template>
  <div class="product-list">
    <div class="product-list__list">
      <MainPromoProductListItemMobile
        v-for="product in productList"
        :key="product.id"
        :product="product"
        class="product-list__item"
      />
    </div>
  </div>
</template>

<script>
import MainProductListMixin from '@/components/NewDesign/Page/Index/mixins/MainPromoProductListMixin'
import MainPromoProductListItemMobile from '@/components/NewDesign/Page/Index/Parts/Promo/ProductList/MainPromoProductListItemMobile.vue'

export default {
  name: 'MainPromoProductListMobile',
  components: { MainPromoProductListItemMobile },
  mixins: [MainProductListMixin],
}
</script>

<style scoped lang="scss">
.product-list {
  &__list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
    width: 100%;
    padding: 4px;
    border-radius: 24px;
    background-color: $color-white;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08), 0 4px 24px 0 rgba(0, 0, 0, 0.12);

    @include screen-down(720px) {
      grid-template-columns: 1fr;
    }
  }

  &__item {
    &:last-child:nth-child(odd) {
      @include screen-up(720px) {
        grid-column: span 2;
      }
    }
  }
}
</style>
